import clsx from 'clsx'
import React from 'react'

import Text from '@/components-latest/primitives/Text'

import Styles from './ExportLoadingNotification.module.scss'

interface IExportLoadingNotificationProps {
  message: string
}

const ExportLoadingNotification: React.FC<IExportLoadingNotificationProps> = ({
  message
}) => {
  return (
    <div className={Styles.notification} data-testid="export-loading-notification">
      <Text variant="nextBody" weight="semiBold" className={Styles.message}>
        {message}
      </Text>
      <div className={Styles.progressBar}>
        <div className={Styles.progressFill} />
      </div>
    </div>
  )
}

export default ExportLoadingNotification

